<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487
      22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z"
      fill="#F7F8FD"
    />
    <g clip-path="url(#clip0_7866_114416)">
      <path
        d="M13.8706 14.6907L11 12.6402L8.12939 14.6907V8.12926C8.12939
        7.91173 8.21581 7.70312 8.36962 7.54931C8.52343 7.39549 8.73205 7.30908
        8.94957 7.30908H13.0504C13.268 7.30908 13.4766 7.39549 13.6304
        7.54931C13.7842 7.70312 13.8706 7.91173 13.8706 8.12926V14.6907Z"
        stroke="#7B87A5"
        stroke-width="1.15789"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7866_114416">
        <rect
          width="9.8421"
          height="9.8421"
          fill="white"
          transform="translate(6.0791 6.07886)"
        />
      </clipPath>
    </defs>
  </svg>
</template>